<header class="ac-header">
	<section class="header grid" [ngClass]="gridClass">
		<section class="row justify-content-right">
			<ng-container *ngFor="let item of GHOST_ELEMENTS">
				<div class="link">
					<ngx-skeleton-loader
						[theme]="{ width: '130px', 'border-radius': '0', height: '25px', 'margin-bottom': '0', 'background-color': '#616161' }"
					></ngx-skeleton-loader>
				</div>
			</ng-container>
		</section>
	</section>
	<div class="mobile-header hidden d-flex-sm">
		<ngx-skeleton-loader [theme]="{ width: '130px', 'border-radius': '0', height: '25px', 'margin-bottom': '0', 'background-color': '#616161' }"></ngx-skeleton-loader>
	</div>
</header>
